var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FEDEE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.3333V25.2222M24 28.8889V28.9011M13 24C13 25.4445 13.2845 26.8749 13.8373 28.2095C14.3901 29.5441 15.2004 30.7567 16.2218 31.7782C17.2433 32.7996 18.4559 33.6099 19.7905 34.1627C21.1251 34.7155 22.5555 35 24 35C25.4445 35 26.8749 34.7155 28.2095 34.1627C29.5441 33.6099 30.7567 32.7996 31.7782 31.7782C32.7996 30.7567 33.6099 29.5441 34.1627 28.2095C34.7155 26.8749 35 25.4445 35 24C35 22.5555 34.7155 21.1251 34.1627 19.7905C33.6099 18.4559 32.7996 17.2433 31.7782 16.2218C30.7567 15.2004 29.5441 14.3901 28.2095 13.8373C26.8749 13.2845 25.4445 13 24 13C22.5555 13 21.1251 13.2845 19.7905 13.8373C18.4559 14.3901 17.2433 15.2004 16.2218 16.2218C15.2004 17.2433 14.3901 18.4559 13.8373 19.7905C13.2845 21.1251 13 22.5555 13 24Z",
    stroke: "#F73A5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.c23756345b919eb15505f7eff85f4970.svg";
export { ForwardRef as ReactComponent };